<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Feedback</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" data-test="header">
        We appreciate your feedback:
    </ion-list-header>

    <ion-list lines="none">
        <ion-item (click)="onSubjectClick()" data-test="subject">
            <ion-label class="ion-text-wrap" position="stacked">Subject</ion-label>
            <ion-input class="ion-padding" type="text" readonly [(ngModel)]="feedback.subject"
                data-test="subject"></ion-input>
        </ion-item>

        <ion-item data-test="body">
            <ion-label class="ion-text-wrap" position="stacked">Body</ion-label>
            <ion-textarea data-test="body" [(ngModel)]="feedback.body" rows="9" required
                placeholder="If you are reporting a bug or requesting a new feature, please be specific.">
            </ion-textarea>
        </ion-item>

        <ion-item data-test="responseRequired">
            <ion-label class="ion-text-wrap">
                <span class="line1">Would you like a response?</span><br />
                <span class="line2">{{feedback.requestResponseStr}}</span>
            </ion-label>
            <ion-toggle data-test="requestResponse" [(ngModel)]="feedback.requestResponse" (ionChange)="onRequestResponseChange()"
                toggle-class="toggle-assertive"></ion-toggle>
        </ion-item>

        <ion-item data-test="priority">
            <ion-label class="ion-text-wrap">
                <span class="line1">Priority?</span><br />
                <span class="line2">{{feedback.priorityStr}}</span>
            </ion-label>
            <ion-toggle data-test="priorityToggle" [(ngModel)]="feedback.priority" (ionChange)="onPriorityChange()"
                toggle-class="toggle-assertive"></ion-toggle>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSendEmailClick()" data-test="sendButton">
            Send Feedback
        </ion-button>
    </ion-toolbar>
</ion-footer>